<template>
  <div>
    <Collapse v-model="value1" simple :disabled="prevent" style="border:0 ">
      <Panel name="1" hide-arrow style="margin-bottom: 20px;">
        <FormTitle
          :titleText="
            lang == 'zh' ? chName.basicInformation : enName.basicInformation
          "
        />
        <Form
          :label-width="150"
          label-position="left"
          class="titleDistance"
          slot="content"
          :disabled="true"
        >
          <Row type="flex" justify="space-between">
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="
                  lang == 'zh' ? chName.serialnumber : enName.serialnumber
                "
              >
                <Input v-model="formItem.applySerialnumber"></Input>
              </FormItem>
            </Col>
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.userName : enName.userName"
              >
                <Input v-model="formItem.applyName"></Input>
              </FormItem>
            </Col>
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="
                  lang == 'zh' ? chName.positionName : enName.positionName
                "
              >
                <Input v-model="formItem.applyPositionName" />
              </FormItem>
            </Col>
          </Row>
          <!-- <Row type="flex" justify="space-between">
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="lang=='zh'?chName.orgsname2:enName.orgsname2">
                <Input disabled v-model="formItem.orgsname2"/>
              </FormItem>
            </Col>                
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="lang=='zh'?chName.orgsname4:enName.orgsname4">
                <Input disabled v-model="formItem.orgsname4"/>
              </FormItem>
            </Col>
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="lang=='zh'?chName.orgsname5:enName.orgsname5">
                <Input disabled v-model="formItem.orgsname5"/>
              </FormItem>
            </Col>
           
          </Row> -->
          <Row type="flex" justify="space-between">
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.hirevalid : enName.hirevalid"
              >
                <Date-picker
                  v-model="formItem.hirevalid"
                  disabled
                  type="date"
                  placeholder=""
                  style="width: 100%;"
                ></Date-picker>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>
      <Panel name="2" hide-arrow style="margin-bottom: 20px;border:0">
        <FormTitle
          :titleText="
            lang == 'zh' ? chName.Contract_renewal : enName.Contract_renewal
          "
        />
        <Tabs :animated="true" slot="content" class="titleDistance">
          <Tab-pane
            :label="
              lang == 'zh' ? chName.contract_resume : enName.contract_resume
            "
            style="width:100%"
          >
            <Row>
              <Col span="23">
                <Table border :columns="columns1" :data="RecordData"></Table>
              </Col>
            </Row>
          </Tab-pane>
        </Tabs>
      </Panel>
      <Panel name="3" hide-arrow style="margin-bottom: 20px;border:0">
        <FormTitle
          :titleText="
            lang == 'zh' ? chName.renewaldecision : enName.renewaldecision
          "
        />
        <Form
          slot="content"
          :label-width="150"
          label-position="left"
          class="titleDistance"
        >
          <Row type="flex" justify="space-between">
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.contractype : enName.contractype"
              >
                <Select v-model="formItem.contracttype" :disabled="isHistory">
                  <Option
                    :value="item.code"
                    v-for="(item, i) in optionList"
                    :key="i"
                    >{{ item.name }}
                  </Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="
                  lang == 'zh' ? chName.contractnumber : enName.contractnumber
                "
              >
                <Input
                  :disabled="isHistory"
                  v-model="formItem.contractnumber"
                />
              </FormItem>
            </Col>
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="
                  lang == 'zh' ? chName.filelocation : enName.filelocation
                "
              >
                <Input :disabled="isHistory" v-model="formItem.filelocation" />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="
                  lang == 'zh' ? chName.newbegindate : enName.newbegindate
                "
              >
                <DatePicker
                  style="width:100%"
                  disabled
                  type="date"
                  v-model="formItem.newContractStartDate"
                  placeholder=""
                ></DatePicker>
              </FormItem>
            </Col>
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="lang == 'zh' ? chName.period : enName.period">
                <Row>
                  <Col span="5"
                    ><Input
                      :disabled="isHistory"
                      v-model="formItem.yearlimit"/></Col
                  >{{ lang == "zh" ? chName.year : enName.year }}
                  <Col span="5"
                    ><Input
                      :disabled="isHistory"
                      v-model="formItem.monthlimit"/></Col
                  >{{ lang == "zh" ? chName.month : enName.month }}
                  <Col span="5"
                    ><Input
                      :disabled="isHistory"
                      v-model="formItem.daylimit"/></Col
                  >{{ lang == "zh" ? chName.day : enName.day }}
                </Row>
              </FormItem>
            </Col>
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.newenddate : enName.newenddate"
              >
                <DatePicker
                  style="width:100%"
                  :disabled="isHistory"
                  v-model="formItem.newContractEndDate"
                  :readonly="isReadonly"
                  type="date"
                  placeholder=""
                  @on-change="timeChange"
                ></DatePicker>
                <Checkbox v-model="formItem.isNoEndContract" disabled>{{
                  lang == "zh" ? chName.isNoEndContract : enName.isNoEndContract
                }}</Checkbox>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col span="24" :xs="24" :sm="24" :md="24" :lg="24">
              <FormItem
                span="3"
                :label="lang == 'zh' ? chName.comment : enName.comment"
              >
                <Input
                  type="textarea"
                  :disabled="isHistory"
                  v-model="formItem.comments"
                />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label-width="150"
                :label="lang == 'zh' ? chName.completion : enName.completion"
              >
                <Checkbox
                  :disabled="isHistory"
                  v-model="formItem.completion"
                ></Checkbox>
              </FormItem>
            </Col>
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label-width="150"
                :label="
                  lang == 'zh' ? chName.approvebylabor : enName.approvebylabor
                "
              >
                <Checkbox
                  :disabled="isHistory"
                  v-model="formItem.approvebylabor"
                ></Checkbox>
              </FormItem>
            </Col>
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label-width="150"
                :label="lang == 'zh' ? chName.paypenalty : enName.paypenalty"
              >
                <Checkbox
                  :disabled="isHistory"
                  v-model="formItem.paypenalty"
                ></Checkbox>
              </FormItem>
            </Col>
          </Row>
          <Row class="btnRight">
            <Col>
              <Button
                v-if="!getQueryVariable('history')"
                class="applyBtnRight"
                @click="submitBtn"
                >{{ lang == "zh" ? chName.agree : enName.agree }}</Button
              >
              <Button
                class="applyBtnRight"
                @click="exportContract"
                v-if="isHistory && formItem.status == '8'"
                >{{
                  lang == "zh" ? chName.exportcontract : enName.exportcontract
                }}</Button
              >
              <Button class="applyBtnRight" @click="returnPage()">{{
                lang == "zh" ? chName.return : enName.return
              }}</Button>
              <Button
                v-if="!getQueryVariable('history')"
                class="applyBtnRight"
                @click="returnThelastonePage"
                >{{ lang == "zh" ? chName.reject : enName.reject }}</Button
              >
            </Col>
          </Row>
        </Form>
      </Panel>
      <Panel name="5" hide-arrow style="margin-bottom: 20px;border:0">
        <!-- 审批历史 -->
        <FormTitle
          :titleText="
            lang == 'zh' ? chName.approvalhistory : enName.approvalhistory
          "
        />
        <Table
          border
          :columns="columns3"
          :data="data3"
          slot="content"
          class="titleDistance"
        >
        </Table>
      </Panel>
      <Spin size="large" fix v-if="spinShow"></Spin>
    </Collapse>
    <Modal
      v-model="showdataAgree"
      :title="lang == 'zh' ? chName.approvalopinion : enName.approvalopinion"
      width="500"
      :mask-closable="false"
    >
      <Input v-model="rejectMessage.message" type="textarea" :rows="5"></Input>
      <div slot="footer">
        <Button @click="yess1">{{
          lang == "zh" ? chName.confirm : enName.confirm
        }}</Button>
        <Button @click="cancell1">{{
          lang == "zh" ? chName.cancel : enName.cancel
        }}</Button>
      </div>
    </Modal>
    <Modal
      v-model="showdataRejected"
      :title="lang == 'zh' ? chName.rejectopinion : enName.rejectopinion"
      width="500"
      :mask-closable="false"
    >
      <Form :rules="ruleValidate" :model="rejectMessage" ref="rejectMessage">
        <FormItem prop="message">
          <Input
            v-model="rejectMessage.message"
            type="textarea"
            :rows="5"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="yess2">{{
          lang == "zh" ? chName.confirm : enName.confirm
        }}</Button>
        <Button @click="cancell2">{{
          lang == "zh" ? chName.cancel : enName.cancel
        }}</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
export default {
  components: {},
  data() {
    return {
      date: new DateUtil(),
      value1: [1, 2, 3, 5],
      formItem: { status: "" },
      chName: {},
      enName: {},
      empoloyee: false,
      RecordData: [],
      optionList: [],
      data3: [],
      prevent: false,
      isReadonly: false,
      isHistory: false,
      spinShow: false,
      showdataAgree: false, //审批意见
      showdataRejected: false, //驳回意见
      rejectMessage: {},
      approval_agent_flg: 0,
      pageInfo: {
        itemCount: 0,
        pageNum: 1,
        pageSize: 10
      },
      total: 0
    };
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    },
    ruleValidate() {
      return {
        message: [
          {
            required: true,
            message:
              this.lang == "zh"
                ? this.chName.rejectopinion
                : this.enName.rejectopinion + "！"
          }
        ]
      };
    },
    columns1() {
      return [
        {
          title:
            this.lang == "zh"
              ? this.chName.contractnumber
              : this.enName.contractnumber,
          key: "contractnumber",
          align: "center",
          width: "200"
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.contractype
              : this.enName.contractype,
          key: "contracttype",
          align: "center",
          width: "200",
          render: (h, params) => {
            var name = "-";
            this.optionList
              ? this.optionList.map((item, index) => {
                  if (item.code == params.row.contracttype) {
                    name = item.name;
                  }
                })
              : "";
            return h("span", name);
          }
        },
        {
          title:
            this.lang == "zh" ? this.chName.begindate : this.enName.begindate,
          key: "begindate",
          align: "center",
          width: "200",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.begindate, "YYYY-MM-DD")
            );
          }
        },
        {
          title: this.lang == "zh" ? this.chName.enddate : this.enName.enddate,
          key: "enddate",
          align: "center",
          width: "200",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.enddate, "YYYY-MM-DD")
            );
          }
        },
        {
          title: this.lang == "zh" ? this.chName.period : this.enName.period,
          key: "contractPeriod",
          align: "center",
          width: "200"
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.filelocation
              : this.enName.filelocation,
          key: "filelocation",
          align: "center",
          width: "490"
        }
      ];
    },
    columns3() {
      return [
        {
          title:
            this.lang == "zh" ? this.chName.stepName : this.enName.stepName,
          key: "stepName",
          align: "center",
          width: "280"
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.approvalperson
              : this.enName.approvalperson,
          key: "userName",
          align: "center",
          width: "280"
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.approvaltime
              : this.enName.approvaltime,
          key: "time",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.time, "YYYY-MM-DD HH:mm")
            );
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.approvalstatus
              : this.enName.approvalstatus,
          key: "status",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              params.row.status == "0"
                ? "通过"
                : params.row.status == "1"
                ? "驳回"
                : ""
            );
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.approvalopinions
              : this.enName.approvalopinions,
          key: "message",
          align: "center",
          width: "435"
        }
      ];
    }
  },
  watch: {
    "formItem.isNoEndContract"(val) {
      if (val == true) {
        this.formItem.newContractEndDate = null;
        this.isReadonly = true;
      } else {
        this.isReadonly = false;
      }
    },
    "formItem.contracttype"(val) {
      if (val == "OneYear") {
        this.formItem.yearlimit = 1;
        this.formItem.monthlimit = 0;
        this.formItem.daylimit = 0;
        this.formItem.isNoEndContract = false;
        this.formItem.newContractEndDate = this.date.addDays(
          this.date.addYears(
            this.formItem.newContractStartDate,
            1,
            "YYYY-MM-DD"
          ),
          -1,
          "YYYY-MM-DD"
        );
      } else if (val == "TwoYear") {
        this.formItem.yearlimit = 2;
        this.formItem.monthlimit = 0;
        this.formItem.daylimit = 0;
        this.formItem.isNoEndContract = false;
        this.formItem.newContractEndDate = this.date.addDays(
          this.date.addYears(
            this.formItem.newContractStartDate,
            2,
            "YYYY-MM-DD"
          ),
          -1,
          "YYYY-MM-DD"
        );
      } else if (val == "ThreeYear") {
        this.formItem.yearlimit = 3;
        this.formItem.monthlimit = 0;
        this.formItem.daylimit = 0;
        this.formItem.isNoEndContract = false;
        this.formItem.newContractEndDate = this.date.addDays(
          this.date.addYears(
            this.formItem.newContractStartDate,
            3,
            "YYYY-MM-DD"
          ),
          -1,
          "YYYY-MM-DD"
        );
      } else if (val == "Unlimit") {
        this.formItem.yearlimit = "";
        this.formItem.monthlimit = "";
        this.formItem.daylimit = "";
        this.formItem.isNoEndContract = true;
        this.formItem.newContractEndDate = "";
      }
    }
  },
  mounted() {
    // 查询国际化
    this.getInternation();
    this.getUserData();
    this.approval_agent_flg = this.getQueryVariable("approval_agent_flg");
  },
  created() {
    this.isHistory = this.getQueryVariable("history") ? true : false;
  },
  methods: {
    getInternation() {
      let Obj = {
        viewType: "Contract_Renew",
        beUsed: "1"
      };
      this.spinShow = true;
      axios.post("/International/applySelectViewSet", Obj).then(res => {
        console.log(res);
        this.chName = res.data[0];
        this.enName = res.data[1];
        // console.log(this.chName)
        this.spinShow = false;
      });
    },
    exportContract() {
      this.spinShow = true;
      axios.post("/wordExport/downloadWord", {}).then(res => {
        this.spinShow = false;
        let fileName = res.dataMap.docName;
        let URL = this.dataURLtoBlob(res.data);
        var reader = new FileReader();
        reader.readAsDataURL(URL);
        reader.onload = function(e) {
          // 兼容IE
          if (window.navigator.msSaveOrOpenBlob) {
            var bstr = atob(e.target.result.split(",")[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr]);
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            // 转换完成，创建一个a标签用于下载
            const a = document.createElement("a");
            a.download = fileName; // 这里写你的文件名
            a.href = e.target.result;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }
        };
      });
    },
    dataURLtoBlob(dataurl) {
      var bstr = atob(dataurl);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: "pdf" });
    },
    timeChange(val) {
      let newBeginTime = this.date.addDays(
        this.formItem.newContractStartDate,
        -1
      );
      let month1 = this.date.diff(val, newBeginTime, 1);
      let month2 = month1 >= 12 ? month1 % 12 : month1;
      this.formItem.monthlimit = month2;
      let day1 = this.date.addMonths(newBeginTime, month1);
      let day2 = this.date.diff(val, day1);
      this.formItem.daylimit = day2;
      this.formItem.yearlimit = this.date.diff(val, newBeginTime, 0);
      this.$forceUpdate();
    },
    getUserData() {
      let arr = {
        instanceId: this.getQueryVariable("instanceId")
      };
      axios
        .post("/contractRenew/selectContractRenewsAllData", arr)
        .then(res => {
          if (res) {
            this.formItem = res.basicInfo;
            this.formItem.status = res.basicInfo.status;
            this.$set(
              this.formItem,
              "isNoEndContract",
              this.formItem.isNoEndContract == 1 ? true : false
            );
            this.$set(
              this.formItem,
              "completion",
              this.formItem.completion == 1 ? true : false
            );
            this.$set(
              this.formItem,
              "approvebylabor",
              this.formItem.approvebylabor == 1 ? true : false
            );
            this.$set(
              this.formItem,
              "paypenalty",
              this.formItem.paypenalty == 1 ? true : false
            );
            this.$set(
              this.formItem,
              "applySerialnumber",
              res.basicInfo.applySerialnumber
            );
            this.data3 = res.logMap;
            this.optionList = res.optionList;
          }
          let arr1 = {
            instanceId: this.getQueryVariable("instanceId")
          };
          axios
            .post("/contractRenew/selectContractRenewHistorical", arr1)
            .then(res => {
              if (res) {
                this.RecordData = res;
              }
            });
        });
    },
    returnPage() {
      //1审批 0 申请
      if (this.getQueryVariable("history") == 1) {
        this.$router.push(
          "/3911E071298B94E27537586515457CF2BA610C6A6F738319/A3FFBEBFDB713E27"
        );
      } else if (this.approval_agent_flg === "1") {
        this.$router.push(
          "/C3904BCDD542D40ECF5E49DF3A1F39D9C587E33DA46A7207/93691ABC763FC67F"
        );
      } else {
        this.$router.push("/27B8ABB6F63EFBBE75D07D383A598492/A3FFBEBFDB713E27");
      }
    },
    submitBtn() {
      this.showdataAgree = true;
    },
    yess1() {
      this.showdataAgree = false;
      this.spinShow = true;
      let arr1 = {
        instanceId: this.getQueryVariable("instanceId"),
        contracttype: this.formItem.contracttype,
        contractnumber: this.formItem.contractnumber,
        filelocation: this.formItem.filelocation,
        newContractStartDate: this.date.dateVal(
          this.formItem.newContractStartDate,
          "YYYY-MM-DD"
        ),
        yearlimit: this.formItem.yearlimit,
        monthlimit: this.formItem.monthlimit,
        daylimit: this.formItem.daylimit,
        newContractEndDate: this.date.dateVal(
          this.formItem.newContractEndDate,
          "YYYY-MM-DD"
        ),
        isnoendcontract: this.formItem.isNoEndContract == true ? 1 : 0,
        comments: this.formItem.comments,
        approvebylabor: this.formItem.approvebylabor == true ? 1 : 0,
        completion: this.formItem.completion == true ? 1 : 0,
        paypenalty: this.formItem.paypenalty == true ? 1 : 0
      };
      axios.post("/contractRenew/updaterContractRenews", arr1).then(res => {
        let arr2 = [
          {
            objData1: { approval_result: "0" },
            stringData1: this.getQueryVariable("taskId"),
            stringData2: this.rejectMessage.message,
            type: "B17"
          }
        ];
        axios.post("/process/execute", arr2).then(res => {
          if (res) {
            let arr3 = {
              ...this.formItem,
              serialnumber: this.formItem.applySerialnumber,
              comment: this.formItem.comments
            };
            axios
              .post("/contractRenew/writeBackContractRenews", arr3)
              .then(res => {
                this.spinShow = false;
                if (res) {
                  this.$Message.info(this.$t("Approval_Completed"));
                  this.$router.push(
                    "/27B8ABB6F63EFBBEF7BD77EC1FE93AE8D5AC2804BF5BD5A1/A3FFBEBFDB713E27"
                  );
                }
              });
          }
        });
      });
    },
    cancell1() {
      this.showdataAgree = false;
    },
    returnThelastonePage() {
      this.showdataRejected = true;
    },
    cancell2() {
      this.showdataRejected = false;
    },
    yess2() {
      this.$refs["rejectMessage"].validate(valid => {
        if (valid) {
          let arr = [
            {
              objData1: { approval_result: "1" },
              stringData1: this.getQueryVariable("taskId"),
              stringData2: this.rejectMessage.message,
              type: "B17"
            }
          ];
          this.showdataRejected = false;
          this.spinShow = true;
          axios.post("/process/execute", arr).then(res => {
            this.spinShow = false;
            this.prevent = false;
            if (res) {
              this.$Message.info(this.$t("审批驳回成功"));
              this.$router.push(
                "/27B8ABB6F63EFBBEF7BD77EC1FE93AE8D5AC2804BF5BD5A1/A3FFBEBFDB713E27"
              );
            }
          });
        }
      });
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    }
  }
};
</script>

<style scoped>
.titleDistance {
  margin: 30px 30px 0 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/process/Apply/ContractRenewApproval.vue